export const addresses = {
  dotNounsToken: "0x1e3516211Fe0CB030802237B4C4CE8277733a3B9",
};
